import type {TStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getDashboardStore = (store: TStore) => store.dashboard;

export const getDashboardResult = createSelector([getDashboardStore], (store) => store.dashboard);
